import { HTMLAttributes, ReactNode, useState } from 'react';
import { twMerge } from 'tailwind-merge';
import { ChevronDown } from './icons/ChevronDown';
import { ChevronUp } from './icons/ChevronUp';

export interface QuestionDropdownProps extends HTMLAttributes<HTMLDivElement> {
  title: string;
  body: ReactNode;
  defaultOpen?: boolean;
  hideTriggerButton?: boolean;
}

export const QuestionDropdown = ({
  title,
  body,
  defaultOpen = false,
  className,
  hideTriggerButton = false,
  ...rest
}: QuestionDropdownProps) => {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div {...rest} className={twMerge('font-manrope flex w-full select-none flex-col gap-5 bg-white p-5', className)}>
      <div className={twMerge('flex items-start', hideTriggerButton && 'hidden')}>
        <button
          type="button"
          aria-expanded={open}
          onClick={() => setOpen(!open)}
          className="flex text-center text-base font-bold leading-normal text-violet-950"
        >
          <span>{title}</span>
          {open ? <ChevronUp width={18} /> : <ChevronDown width={18} />}
        </button>
      </div>
      <div
        hidden={!open}
        className="self-stretch text-sm font-medium leading-normal text-gray-800 transition delay-150 ease-linear"
      >
        {body}
      </div>
    </div>
  );
};
